import { Grid, styled } from '@mui/material';

const Section2Container = styled(Grid)(({ theme }) => ({
  maxWidth: 1100,
  margin: '0 auto',
  padding: '120px 0',
  display: 'flex',
  flexFlow: 'row wrap',
  [theme.breakpoints.down('md')]: {
    maxWidth: 560,
  },
  [theme.breakpoints.down('md')]: {
    padding: '120px 32px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '2.5rem 1rem',
  },
}));

const Section2Card = styled(Grid)(({ theme, smallTitle }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 60,
  maxWidth: 550,
  gap: 24,
  [theme.breakpoints.down('md')]: {
    padding: 32,
    maxWidth: 280,
    flexDirection: 'column',
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%',
    border: '1px solid #E8E8E8 !important',
    boxShadow: 'none !important',
  },
  div: {
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
    svg: {
      flexShrink: 0,
    },
    h1: {
      fontSize: smallTitle ? 55 : 60,
      fontWeight: 700,
      lineHeight: '60px',
      color: '#04246B',
      marginBottom: 8,
      [theme.breakpoints.down('md')]: {
        fontSize: 40,
        lineHeight: '56px',
      },
    },
    h2: {
      fontSize: 40,
      fontWeight: 600,
      lineHeight: '39px',
      [theme.breakpoints.down('md')]: {
        fontSize: 28,
        lineHeight: '40px',
      },
    },
  },
}));

const Section2 = () => (
  <Section2Container container justifyContent="center">
    <Section2Card
      item
      sm={12}
      md={6}
      style={{ boxShadow: '0px 2px 12px 0px rgba(0, 0, 0, 0.15)', borderRadius: '16px 0 16px 0' }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
        <path
          d="M65.9524 88.0952L56.6667 97.2619C54.8413 99.0873 52.619 100 50 100C47.381 100 45.1587 99.0873 43.3333 97.2619L34.0476 88.0952H21.4286C18.8095 88.0952 16.5667 87.1619 14.7 85.2952C12.8333 83.4286 11.9016 81.1873 11.9048 78.5714V65.9524L2.7381 56.6667C0.912699 54.8413 0 52.619 0 50C0 47.381 0.912699 45.1587 2.7381 43.3333L11.9048 34.0476V21.4286C11.9048 18.8095 12.8381 16.5667 14.7048 14.7C16.5714 12.8333 18.8127 11.9016 21.4286 11.9048H34.0476L43.3333 2.7381C45.1587 0.912699 47.381 0 50 0C52.619 0 54.8413 0.912699 56.6667 2.7381L65.9524 11.9048H78.5714C81.1905 11.9048 83.4333 12.8381 85.3 14.7048C87.1667 16.5714 88.0984 18.8127 88.0952 21.4286V34.0476L97.2619 43.3333C99.0873 45.1587 100 47.381 100 50C100 52.619 99.0873 54.8413 97.2619 56.6667L88.0952 65.9524V78.5714C88.0952 81.1905 87.1619 83.4333 85.2952 85.3C83.4286 87.1667 81.1873 88.0984 78.5714 88.0952H65.9524ZM50 90.4762L61.9048 78.5714H78.5714V61.9048L90.4762 50L78.5714 38.0952V21.4286H61.9048L50 9.52381L38.0952 21.4286H21.4286V38.0952L9.52381 50L21.4286 61.9048V78.5714H38.0952L50 90.4762ZM50 61.7857L59.0476 67.2619C59.9206 67.8175 60.7936 67.7968 61.6667 67.2C62.5397 66.6032 62.8571 65.7905 62.619 64.7619L60.2381 54.4048L68.3333 47.381C69.127 46.6667 69.3651 45.8143 69.0476 44.8238C68.7302 43.8333 68.0159 43.2968 66.9048 43.2143L56.3095 42.381L52.1429 32.619C51.746 31.6667 51.0317 31.1905 50 31.1905C48.9683 31.1905 48.254 31.6667 47.8571 32.619L43.6905 42.381L33.0952 43.2143C31.9841 43.2936 31.2698 43.8302 30.9524 44.8238C30.6349 45.8175 30.873 46.6698 31.6667 47.381L39.7619 54.4048L37.381 64.7619C37.1429 65.7937 37.4603 66.6079 38.3333 67.2048C39.2063 67.8016 40.0794 67.8206 40.9524 67.2619L50 61.7857Z"
          fill="#CDA07D"
        />
      </svg>
      <div>
        <h1>30+</h1>
        <h2>YEARS OF EXPERIENCE</h2>
      </div>
    </Section2Card>
    <Section2Card
      item
      sm={12}
      md={6}
      style={{ borderRight: '2px solid #E8E8E8', borderTop: '2px solid #E8E8E8', borderRadius: '0 16px 0 0' }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="109" height="120" viewBox="0 0 109 120" fill="none">
        <path
          d="M64.5 46.5889C59.5 40.9352 46.165 39.0547 46.165 50.3621C46.165 61.6695 64.5 56.0158 64.5 67.3171C64.5 78.6185 49.5 78.6246 44.5 71.0842M54.5 76.3337V84.2844M54.5 42.099V35.2814M4.5 35.2814L53.16 5.47538C53.5761 5.22087 54.0349 5.08838 54.5 5.08838C54.9651 5.08838 55.4239 5.22087 55.84 5.47538L104.5 35.2814"
          stroke="#CDA07D"
          stroke-width="9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M94.5 53.6577V102.661C94.5 105.91 93.4464 109.026 91.5711 111.323C89.6957 113.621 87.1522 114.911 84.5 114.911H24.5C21.8478 114.911 19.3043 113.621 17.4289 111.323C15.5536 109.026 14.5 105.91 14.5 102.661V53.6577"
          stroke="#CDA07D"
          stroke-width="9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div>
        <h1>250M</h1>
        <h2>SALES VOLUME</h2>
      </div>
    </Section2Card>
    <Section2Card
      item
      sm={12}
      md={6}
      smallTitle
      style={{ borderLeft: '2px solid #E8E8E8', borderBottom: '2px solid #E8E8E8', borderRadius: '0 0 0 16px' }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="81" height="128" viewBox="0 0 81 128" fill="none">
        <path
          d="M26.7115 90.1047H51.6061L64.433 54.3288C66.2364 49.3029 66.6133 43.9706 65.5314 38.7898C64.4496 33.609 61.9413 28.7343 58.2218 24.5843L42.1026 6.60416C41.7534 6.2142 41.3067 5.89875 40.7966 5.68178C40.2865 5.46482 39.7264 5.35205 39.1588 5.35205C38.5912 5.35205 38.0311 5.46482 37.521 5.68178C37.0109 5.89875 36.5642 6.2142 36.215 6.60416L20.0958 24.5843C16.3763 28.7343 13.868 33.609 12.7862 38.7898C11.7043 43.9706 12.0812 49.3029 13.8846 54.3288L26.7115 90.1047ZM26.7115 90.1047L8.04056 100.952C8.04056 100.952 -4.40673 79.2569 17.376 65.6973M26.7115 106.376C26.7115 117.224 39.1588 122.648 39.1588 122.648C39.1588 122.648 51.6061 117.224 51.6061 106.376M63.624 65.6973C85.4067 79.2569 72.9594 100.952 72.9594 100.952L54.2885 90.1047"
          stroke="#CDA07D"
          stroke-width="9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M39.1524 57.5598C35.8511 57.5598 32.6851 56.4169 30.3508 54.3825C28.0165 52.3482 26.7051 49.589 26.7051 46.712C26.7051 43.835 28.0165 41.0758 30.3508 39.0415C32.6851 37.0071 35.8511 35.8643 39.1524 35.8643C42.4536 35.8643 45.6196 37.0071 47.9539 39.0415C50.2883 41.0758 51.5997 43.835 51.5997 46.712C51.5997 49.589 50.2883 52.3482 47.9539 54.3825C45.6196 56.4169 42.4536 57.5598 39.1524 57.5598Z"
          stroke="#CDA07D"
          stroke-width="9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div>
        <h1>SUCESS- DRIVING</h1>
        <h2>TACTICS</h2>
      </div>
    </Section2Card>
    <Section2Card
      item
      sm={12}
      md={6}
      smallTitle
      style={{ boxShadow: '0px 2px 12px 0px rgba(0, 0, 0, 0.15)', borderRadius: '16px 0 16px 0' }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="96" viewBox="0 0 100 96" fill="none">
        <path
          d="M14.7086 60.4586C18.4761 60.4586 22.0893 58.962 24.7534 56.2979C27.4174 53.6339 28.914 50.0207 28.914 46.2531C28.914 42.4856 27.4174 38.8724 24.7534 36.2084C22.0893 33.5443 18.4761 32.0477 14.7086 32.0477C10.9402 32.0477 7.32622 33.5446 4.6616 36.2093C1.99697 38.8739 0.5 42.4879 0.5 46.2563C0.5 50.0246 1.99697 53.6386 4.6616 56.3032C7.32622 58.9679 10.9402 60.4648 14.7086 60.4648V60.4586ZM73.874 29.3103C77.6415 29.3103 81.2548 27.8137 83.9188 25.1496C86.5828 22.4856 88.0795 18.8724 88.0795 15.1049C88.0795 11.3373 86.5828 7.72414 83.9188 5.0601C81.2548 2.39606 77.6415 0.899414 73.874 0.899414C70.1065 0.899414 66.4933 2.39606 63.8293 5.0601C61.1652 7.72414 59.6686 11.3373 59.6686 15.1049C59.6686 18.8724 61.1652 22.4856 63.8293 25.1496C66.4933 27.8137 70.1065 29.3103 73.874 29.3103ZM46.7505 82.8198C41.7291 81.7579 37.0069 79.5918 32.9263 76.4786C28.8457 73.3655 25.509 69.3833 23.1581 64.8208C19.3564 66.5493 15.1167 67.0727 11.0088 66.3208C13.8492 73.3434 18.3712 79.5608 24.1772 84.4265C29.9833 89.2921 36.8958 92.657 44.3069 94.2255C47.6192 94.9317 51.0066 95.2816 54.3939 95.2629C51.7857 91.8445 50.3284 87.6872 50.2316 83.3886C49.0625 83.2572 47.9007 83.0674 46.7505 82.8198ZM70.6742 97.1003C72.5397 97.1003 74.3869 96.7329 76.1104 96.019C77.8339 95.3051 79.3999 94.2587 80.719 92.9396C82.0381 91.6205 83.0844 90.0545 83.7983 88.331C84.5122 86.6076 84.8797 84.7603 84.8797 82.8948C84.8797 81.0294 84.5122 79.1821 83.7983 77.4586C83.0844 75.7352 82.0381 74.1692 80.719 72.8501C79.3999 71.531 77.8339 70.4846 76.1104 69.7707C74.3869 69.0568 72.5397 68.6894 70.6742 68.6894C66.9067 68.6894 63.2935 70.186 60.6294 72.8501C57.9654 75.5141 56.4688 79.1273 56.4688 82.8948C56.4688 86.6624 57.9654 90.2756 60.6294 92.9396C63.2935 95.6037 66.9067 97.1003 70.6742 97.1003ZM90.4419 77.6764C96.5332 69.9943 100.039 60.5825 100.458 50.7875C100.876 40.9924 98.1865 31.3158 92.773 23.1419C91.1337 27.0078 88.3453 30.2761 84.7859 32.5039C87.6267 37.8694 89.0156 43.8842 88.815 49.9519C88.6144 56.0197 86.8312 61.9296 83.6422 67.0957C86.9679 69.8173 89.3479 73.5207 90.4419 77.6764ZM13.6149 25.8855C17.7838 25.6671 21.9201 26.7268 25.4705 28.9229C28.6017 24.3989 32.7653 20.6856 37.6167 18.0904C42.4681 15.4951 47.8678 14.0926 53.3689 13.9987C53.6002 9.81142 55.1001 5.79289 57.6812 2.48058C48.8745 1.81547 40.0598 3.66139 32.26 7.80412C24.4602 11.9468 17.995 18.2165 13.6149 25.8855Z"
          fill="#CDA07D"
        />
      </svg>
      <div>
        <h1>VERSATILE</h1>
        <h2>EXPERTISE</h2>
      </div>
    </Section2Card>
  </Section2Container>
);

export default Section2;
